

<app-modal-header
  (close)="close()"
  [highlighted]="true">
  <span slot="breadcrumb">
    {{ 'admin.events.new-event-modal.title' | translate }}
  </span>
  
  <div slot="title">
    <app-input-textarea-subtle [FC]="form.controls.title" [autoFocus]="true" [variant]="'light'" [placeholder]="'admin.events.new-event-modal.event-title-input-placeholder' | translate" [attr.data-test]="'new-event-title-input'"></app-input-textarea-subtle>
    <!-- <app-blank-input [FC]="form.controls.title" [autofocus]="true" [placeholder]="'admin.events.new-event-modal.event-title-input-placeholder' | translate"></app-blank-input> -->
  </div>

  <div slot="undercontent">
  
    <p-tabView [activeIndex]="tabActiveIndex" (activeIndexChange)="onTabIndexChange($event)" class="compensate-padding">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span [attr.data-test]="'new-event-tab-general'">
            {{ 'admin.new-shop-item-modal.tab.general.label' | translate }}
          </span>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <span [attr.data-test]="'new-event-tab-custom'">
            {{ 'admin.new-shop-item-modal.tab.custom.label' | translate }}
          </span>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</app-modal-header>

<div class="modal-body ">

  <div class="">
    @if (tabActiveIndex === Tabs.GENERAL) {
      <ng-container *ngTemplateOutlet="general"></ng-container>
    } @else if (tabActiveIndex === Tabs.CUSTOM) {
      <ng-container *ngTemplateOutlet="custom"></ng-container>
    }
  </div>

</div>

<div class="modal-footer">

  <button
    (click)="close()"
    pButton
    label="{{ 'admin.events.new-event-modal.cancel-btn.label' | translate }}"
    class="p-button-sm p-button-plain p-button-text flex-1"
    [attr.data-test]="'new-event-cancel-btn'">
  </button>

  @if (tabActiveIndex === Tabs.GENERAL) {
    <button
      [loading]="creatingEvent"
      [disabled]="fetchingUrlId || creatingEvent"
      (click)="onCreate()"
      pButton
      label="{{ 'admin.events.new-event-modal.submit-btn.label' | translate }}"
      [attr.data-test]="'new-event-submit-btn'"
      class="p-button-sm flex-1">
    </button>
  }
</div>



<ng-template #general>

  <ng-container  [formGroup]="form">

    
  
    <span *ngIf="emailFC" class="">
      <input
        type="text"
        pInputText
        formControlName="email"
        placeholder="{{ 'admin.events.new-event-modal.email-input-placeholder' | translate }}"
        />
    </span>


    <!-- <p class="m-0">{{ Env.baseUrl }}/<b>{{ urlId }}</b></p> -->
  
    <div class="">
      <p class="text-xs">{{ 'admin.events.new-event-modal.currency-input-label' | translate }}</p>
      <p-multiSelect
        [options]="availableCurrencies"
        [showHeader]="false"
        display="chip"
        placeholder="{{ 'admin.events.new-event-modal.currency-input-placeholder' | translate }}"
        formControlName="currencies"
        class="w-full"
        styleClass="w-full"
        [attr.data-test]="'new-event-currency-input'">
      </p-multiSelect>
    </div>

    <div class="modal-body-divider"></div>

  
    <div class="">
      <app-event-type-radio-input [FC]="form.controls.format"></app-event-type-radio-input>
    </div>

    <p class="text-xs mb-0 mt-3">
      {{ 'admin.events.new-event-modal.changeable-info-text' | translate }}
    </p>

    
  
  </ng-container>
</ng-template>

<ng-template #custom>
  <h5>
    {{ 'admin.events.new-event-modal.tab.custom.tbd-label' | translate}}
  </h5>
</ng-template>